import { parsePhoneNumberWithError, type CountryCode } from 'libphonenumber-js';

export const isValidPhoneNumber = (
  phoneNumber: string,
  countryCode?: CountryCode,
): boolean => {
  if (!phoneNumber.trim()) return false;

  try {
    return parsePhoneNumberWithError(phoneNumber, countryCode ?? 'US').isValid();
  } catch {
    return false;
  }
};
